import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { motion } from "framer-motion";

import ProfileImage from "./ProfileImage";
import BusinessDescription from "./BusinessDescription";
import CoverImage from "./CoverImage";

const MotionContainer = motion(Container);

// ——— Netflix-ish tokens (design only)
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  text: "#ffffff",
  muted: "rgba(255,255,255,0.78)",
  border: "rgba(255,255,255,0.12)",
  red: "#E50914",
};

const BusinessProfilePage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: COLORS.bg,
        color: COLORS.text,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CoverImage />

      <MotionContainer
        maxWidth="lg"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        sx={{ mt: { xs: -10, md: -12 }, pb: 10 }}
      >
        <Stack spacing={{ xs: 4, md: 6 }}>
          <ProfileImage />

          <BusinessDescription />
        </Stack>
      </MotionContainer>
    </Box>
  );
};

export default BusinessProfilePage;
